export let debugMode = false;
export function toggleDebug(debug) {
    debugMode = debug;
}
export function debug(...args) {
    if (debugMode) {
        console.log('[DEBUG][PlayerManager]', ...args);
    }
}
debug.warn = (...args) => {
    if (debugMode) {
        console.warn('[DEBUG][PlayerManager]', ...args);
    }
};
debug.verbose = (...args) => {
    if (debugMode === 'verbose') {
        debug(...args);
    }
};
